const initialState = {
    chapterData: {
        data: {
            group: {},
            colorScale: {},
            chapterDescription: {},
            chapterConstants: {},
            tofData: []
        },
        loading: false,
        success: false,
        error: false
    }
};

export default initialState;